import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LucideAngularModule, Search } from 'lucide-angular';
import { SearchBoxComponent } from './search-box.component';

@NgModule({
  imports: [CommonModule, LucideAngularModule.pick({ Search })],
  declarations: [SearchBoxComponent],
  exports: [SearchBoxComponent],
})
export class SearchBoxModule {}
